export default __webpack_public_path__ + "static/media/card3.65590ad7.svg";